module.exports = __webpack_public_path__ + "img/SV.4c66b9cc.png";